import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React from 'react';
import { Box } from '@hub/box';
import { UnorderedList, ListItem } from '@hub/list';
import { H2 } from '@hub/heading';
import { Button } from '@hub/button';
import { Link } from '@hub/link';
import { DisplayForHitWithHiglighting } from '../get-display-name-for-hit';
import getUrlForHit from '../get-url-for-hit';
import NewCentreSelector from '../../../hub-components/new-centre-selector';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const ResultsSection = _ref => {
  let {
    source,
    items,
    auto,
    refsAndCursor,
    itemCountSoFar,
    context
  } = _ref;
  if (items.length === 0) {
    return null;
  }
  const elems = refsAndCursor.autocompleteRefs.getElems();
  return /*#__PURE__*/_jsxs(Box, {
    "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Box",
    children: [/*#__PURE__*/_jsx(H2, {
      sx: {
        fontSize: 'font-md',
        fontWeight: 'medium',
        lineHeight: 'base',
        color: 'licorice',
        marginTop: 'spacing-lg',
        textTransform: 'uppercase',
        marginBottom: 'spacing-xs'
      },
      "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Box_H2",
      children: source.sourceId
    }), /*#__PURE__*/_jsx(UnorderedList, _objectSpread(_objectSpread({}, auto.getListProps(elems)), {}, {
      sx: {
        listStyle: 'none',
        margin: 'spacing-none',
        padding: 'spacing-none'
      },
      "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Box_UnorderedList",
      children: items.map((item, i) => {
        const props = auto.getItemProps(_objectSpread({
          item,
          source
        }, elems));
        const href = getUrlForHit(item, context);
        return /*#__PURE__*/_jsx(ListItem, _objectSpread(_objectSpread({}, props), {}, {
          // workaround `props` having misleading types
          onClick: props.onClick,
          onMouseEnter: props.onMouseEnter,
          onMouseLeave: props.onMouseLeave,
          sx: {
            paddingY: 'spacing-xs',
            '&:hover, &:focus-within': {
              background: 'smoke',
              cursor: 'pointer'
            }
          },
          "data-id": "search-modal-autocomplete_results-panel_ResultsSection_ListItem",
          children: /*#__PURE__*/_jsx(Link, {
            as: "a",
            ref: elem => {
              const {
                current
              } = refsAndCursor.autocompleteRefs.itemsRef;
              if (current) {
                current[itemCountSoFar + i] = elem;
              }
            },
            href: href,
            onKeyDown: e => {
              if (e.key === 'ArrowDown') {
                refsAndCursor.moveDown();
                e.preventDefault();
              } else if (e.key === 'ArrowUp') {
                refsAndCursor.moveUp();
                e.preventDefault();
              }
            },
            "data-id": "search-modal-autocomplete_results-panel_ResultsSection_ListItem_Link",
            children: /*#__PURE__*/_jsx(DisplayForHitWithHiglighting, {
              hit: item,
              context: context,
              "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Link_DisplayForHitWithHiglighting"
            })
          })
        }), i);
      })
    }))]
  });
};
const ResultsSections = _ref2 => {
  let {
    collections,
    refsAndCursor,
    autocomplete,
    context
  } = _ref2;
  let itemCountSoFar = 0;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: (collections !== null && collections !== void 0 ? collections : []).map((collection, index) => {
      const key = "source-".concat(index);
      const element = /*#__PURE__*/_jsx(ResultsSection, _objectSpread(_objectSpread({
        refsAndCursor: refsAndCursor,
        auto: autocomplete,
        itemCountSoFar: itemCountSoFar,
        context: context
      }, collection), {}, {
        "data-id": "search-modal-autocomplete_results-panel_ResultsSection"
      }), key);
      itemCountSoFar += collection.items.length;
      return element;
    })
  });
};
const ResultsPanel = _ref3 => {
  let {
    autocomplete,
    query,
    collections,
    refsAndCursor,
    context,
    backgroundColor
  } = _ref3;
  const refs = refsAndCursor.autocompleteRefs;
  const isEmptyQueryNational = !context.centre && !query && !context.specialSearchKind;
  const isSpecialCentresSearch = context.specialSearchKind === 'centres';
  if (isEmptyQueryNational || isSpecialCentresSearch) {
    return /*#__PURE__*/_jsx(NewCentreSelector, {
      query: query,
      heading: "Find a Westfield centre",
      mode: "search",
      backgroundColor: backgroundColor,
      "data-id": "search-modal-autocomplete_results-panel_ResultsSection_NewCentreSelector"
    });
  }
  return /*#__PURE__*/_jsxs(Box, _objectSpread(_objectSpread({
    ref: refs.panelRef
  }, autocomplete.getPanelProps(refs.getElems())), {}, {
    sx: {
      background: backgroundColor,
      width: '100%',
      paddingRight: 'spacing-md'
    },
    "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Box",
    children: [/*#__PURE__*/_jsx(ResultsSections, {
      context,
      autocomplete,
      collections,
      refsAndCursor,
      query,
      "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Box_ResultsSections"
    }), query && (query === null || query === void 0 ? void 0 : query.length) > 0 ? /*#__PURE__*/_jsx(Button, {
      type: "submit",
      colorScheme: "licorice",
      variant: "solid",
      sx: {
        width: '100%',
        marginTop: 'spacing-lg',
        marginBottom: 'spacing-md'
      },
      ref: refs.seeAllRef,
      onKeyDown: e => {
        if (e.key === 'ArrowUp') {
          refsAndCursor.moveUp();
          e.preventDefault();
        }
      },
      "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Button",
      children: "See all results"
    }) : /*#__PURE__*/_jsx(Box, {
      sx: {
        paddingBottom: 'spacing-md'
      },
      "data-id": "search-modal-autocomplete_results-panel_ResultsSection_Box"
    })]
  }));
};
export default ResultsPanel;